<div class="phone-call-widget" dropdown>
  <button id="button-nested-print" dropdownToggle type="button" class="btn btn-outline-primary btn-icon-only" aria-controls="dropdown-nested-print" triggers="click" placement="auto" container="body"
    [ngbPopover]="phoneCallOptionsPopover" popoverClass="phone-call-actions-popover">
    <i class="fas fa-phone" aria-hidden="true"></i>
  </button>

  <!-- Phone Call Options Popover Template -->
  <ng-template #phoneCallOptionsPopover>
    <div class="general-actions-menu">
      <div class="action-item">
        <app-whatsapp-widget [phoneNumber]="phoneNumber" [customerId]="customerId" [orderId]="orderId"></app-whatsapp-widget>
      </div>
      <div class="action-item">
        <app-voip-call-start-widget [phoneNumber]="phoneNumber" [customerId]="customerId"></app-voip-call-start-widget>
      </div>
    </div>
  </ng-template>

</div>